import { http } from './index';
import {IReqScheduleParams,IAddScheduleParams ,IGetScheduleParams,IExcelImportList,IExcelImport,IExportProps} from '@types';

//获取私教坐席列表
export const getScheduleList = (params: any) => http.post('/teaching-workbench/booking/schedule-list', params);

//新增坐席
export const addSchedule = (params: IAddScheduleParams) => http.post('/teaching-workbench/booking/schedule-add', params);

//更新坐席
export const updateSchedule = (params: IAddScheduleParams) => http.post('/teaching-workbench/booking/schedule-update', params);

//查看坐席
export const checkSchedule = (id: number) => http.get(`/teaching-workbench/booking/${id}/schedule-info`);

//坐席操作记录
export const getScheduleLog = (params: IGetScheduleParams) => http.post('/teaching-workbench/api/v1/schedule/schedule-log', params);

//删除坐席
export const deleteSchedule = (params: {ids:number[]|string []}) => http.post('/teaching-workbench/booking/schedule-del', params);

//导入日志列表
export const getExcelImportList = (params: IExcelImportList) => http.post('/olaf/api/v1/excel/excelImportList', params);

//导入日志
export const excelImport = (params:IExcelImport) => http.post('/teaching-workbench/api/v1/schedule/excel-import' ,params);

//导出
export const scheduleExport = (params: IExportProps) => http.post('/teaching-workbench/booking/schedule/export', params, { responseType: 'blob'});
